import { z } from "zod";

import { EquipmentCategory } from "../../-api";

import { EquipmentTableColumns } from "./-table/type";

export const EquipmentTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),

  // ソート
  sortColumn: z.nativeEnum(EquipmentTableColumns).optional(),
  orderDirection: z.enum(["asc", "desc"]).optional(),

  // タブフィルタ
  category: z.nativeEnum(EquipmentCategory).default(EquipmentCategory.ALL),

  // フィルタ
  freeText: z.string().optional(),

  // 複数選択フィルタ (APIスキーマ準拠)
  equipmentTypeIdIn: z.array(z.string()).optional(),
  equipmentItemIdIn: z.array(z.string()).optional(),
  assignedWorkerIdIn: z.array(z.string()).optional(),
  placementPlaceIdIn: z.array(z.string()).optional(),
});

export type EquipmentTableFilterType = z.infer<
  typeof EquipmentTableFilterSchema
>;
